import * as React from 'react';

function SvgMessage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(0,3)">
        <path
          d="M10.625.625a8.737 8.737 0 00-7.43 13.354l-2.57 5.396 5.395-2.57A8.75 8.75 0 1010.625.625v0z"
          stroke="#A381C5"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 9.063a.312.312 0 100 .624.312.312 0 000-.624zm3.75 0a.312.312 0 100 .624.312.312 0 000-.624zm3.75 0a.312.312 0 100 .624.312.312 0 000-.624z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default SvgMessage;
